var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fae-charts-trend"},[(_vm.hasNumber)?_c('div',{staticClass:"charts"},[_c('dv-charts',{attrs:{"option":_vm.trendOption}})],1):_c('noData',{attrs:{"mes":'暂无数据'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }